import React, { useState } from 'react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Box, Heading, Button, useDisclosure, HStack } from '@chakra-ui/react'
import { FiPieChart } from 'react-icons/fi'
import { RoletaProvider } from './hooks/RoletaContext'
import { TabelaClientes } from './components/TabelaClientes'
import { ModalSumarioPremios } from './components/ModalSumarioPremios'

export const RoletaDaSorte = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <HeadingPages name="Roleta da sorte" />
      <RoletaProvider>
        <Box p={5}>
          <HStack justifyContent="space-between" mb={4}>
            <Heading size="md">Gerenciamento de Sorteios</Heading>
            <Button leftIcon={<FiPieChart />} colorScheme="blue" onClick={onOpen}>
              Sumário de Brindes
            </Button>
          </HStack>

          <TabelaClientes />
          <ModalSumarioPremios isOpen={isOpen} onClose={onClose} />
        </Box>
      </RoletaProvider>
    </>
  )
}
